export default "__VITE_ASSET__bc6f1bb9__"